<template>
  <Layout>
    <form @submit.prevent>
      <div class="row justify-content-center">
        <div class="col-md-8 col-lg-6 col-xl-5">
          <div class="card overflow-hidden">
            <div class="bg-soft-primary">
              <div class="row">
                <div class="col-7">
                  <div class="text-primary p-4">
                    <h4 class="text-dark">TuneSoft</h4>
                    <h5 class="text-primary">{{ $t("account.new") }}</h5>
                  </div>
                </div>
                <div class="col-5 align-self-end">
                  <img src="@/assets/images/profile-img.png" alt class="img-fluid" />
                </div>
              </div>
            </div>
            <br />
            <div class="card-body pt-0">
              <div>
                <div class="avatar-md profile-user-wid mb-4">
                  <span class="avatar-title rounded-circle bg-light">
                    <img
                      :src="whiteLabel || require('@/assets/images/logo-small.png')"
                      :class="['rounded-circle', whiteLabel ? 'w-100 h-100' : '']"
                      alt
                      class="rounded-circle"
                      height="60"
                    />
                  </span>
                </div>
              </div>

              <div v-if="notification" :class="'alert :' + notification.type">
                {{ notification.message }}
              </div>

              <sweet-input
                :isValid="!$v.form.name.$error"
                @input="$v.form.name.$touch()"
                v-model="form.name"
                type="name"
                layout="vertical"
                inputClass="mt"
                :placeholder="$t('auth.placeholder.name-surname')"
                :label="$t('common.name-surname2')"
              />
              <div v-if="$v.form.name.$error" class="text-danger">
                <div v-if="!$v.form.name.required">
                  {{ $t("common.required") }}
                </div>
              </div>

              <sweet-input
                :isValid="!$v.form.email.$error"
                @input="$v.form.email.$touch()"
                v-model="form.email"
                type="email"
                layout="vertical"
                inputClass="mt"
                :placeholder="$t('auth.placeholder.email')"
                :label="$t('common.email')"
                class="mt-2"
              />
              <div v-if="$v.form.email.$error" class="text-danger">
                <div v-if="!$v.form.email.required">
                  {{ $t("common.required") }}
                </div>
                <div v-if="!$v.form.email.lowercase">
                  {{ $t("validation.email.lowercase") }}
                </div>
              </div>

              <sweet-input
                :isValid="!$v.form.password.$error"
                @input="$v.form.password.$touch()"
                v-model="form.password"
                type="password"
                layout="vertical"
                inputClass="mt"
                :placeholder="$t('auth.placeholder.password')"
                :label="$t('common.password')"
                labelClass="mt-2"
              />

              <div v-if="$v.form.password.$error" class="text-danger">
                <div v-if="!$v.form.password.required">
                  {{ $t("validation.password.required") }}
                </div>
                <div v-else-if="!$v.form.password.containsUppercase">
                  {{ $t("validation.password.uppercase") }}
                </div>
                <div v-else-if="!$v.form.password.containsLowercase">
                  {{ $t("validation.password.lowercase") }}
                </div>
                <div v-else-if="!$v.form.password.containsNumber">
                  {{ $t("validation.password.number") }}
                </div>
                <div v-else-if="!$v.form.password.containsSpecial">
                  {{ $t("validation.password.special") }}
                </div>
                <div v-else-if="!$v.form.password.minLength">
                  {{ $t("validation.password.minlength") }}
                </div>
                <div v-else-if="!$v.form.password.maxLength">
                  {{ $t("validation.password.maxlength") }}
                </div>
              </div>

              <h6 class="mt-2">{{ $t("common.language") }}</h6>
              <multiselect
                v-model="form.language"
                track-by="language"
                :placeholder="$t('common.language-select')"
                :options="languages"
                :searchable="false"
                :allow-empty="false"
                :show-labels="false"
                @select="onSelect"
              >
                <template slot="singleLabel" slot-scope="{ option }">
                  <img :src="`${option.flag}`" alt="user-image" class="mr-1" height="12" />
                  <span class="align-middle">{{ option.title[option.language] }}</span>
                </template>
                <template slot="option" slot-scope="{ option }">
                  <img :src="`${option.flag}`" alt="user-image" class="mr-1" height="12" />
                  <span class="align-middle">{{ option.title[option.language] }}</span>
                </template>
              </multiselect>

              <h6 class="mt-2">{{ $t("timezone.name") }}</h6>

              <multiselect
                v-if="timezones"
                v-model="form.timezone"
                track-by="abbr"
                :placeholder="$t('timezone.select-time')"
                :options="timezones"
                :searchable="true"
                :allow-empty="false"
                :show-labels="false"
                label="text"
                @select="onSelect"
              >
              </multiselect>

              <div v-if="enableRecaptcha" class="mt-4">
                <vue-recaptcha @verify="handleRecaptchaVerify" ref="recaptcha" :sitekey="recaptchaKey" size="invisible"> </vue-recaptcha>
                <b-button type="submit" @click="register" variant="primary" class="btn-block" :disabled="$v.form.$invalid || isRequesting">{{ $t("account.register") }} </b-button>
              </div>

              <div v-else class="mt-4">
                <b-button type="submit" variant="primary" class="btn-block" @click="register" :disabled="$v.form.$invalid || isRequesting">{{ $t("account.register") }} </b-button>
              </div>
            </div>
            <!-- end card-body -->
          </div>
          <!-- end card -->

          <div class="mt-4 text-center">
            <p>
              {{ $t("account.already-have-an-account") }}
              <router-link tag="a" to="/login" class="font-weight-medium text-primary">{{ $t("common.login") }}</router-link>
            </p>
            <br />
            <div class="mt-4 text-center">
              <p>© {{ new Date().getFullYear() }} Tunesoft</p>
            </div>
            <!-- TKP-236 n.11: "powered by Phexum" kalktı -->
          </div>
        </div>
        <!-- end col -->
      </div>
      <!-- end row -->
    </form>
  </Layout>
</template>

<script>
import appConfig from "@/app.config";

import Layout from "@/layouts/account/auth";

import { VueRecaptcha } from "vue-recaptcha";
import { email, maxLength, minLength, required } from "vuelidate/lib/validators";

export default {
  page: {
    title: "Register",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, VueRecaptcha },
  data() {
    return {
      form: { name: undefined, email: undefined, password: undefined, timezone: undefined, language: undefined },
      formError: undefined,
      isRequesting: false,
    };
  },
  validations: {
    form: {
      password: {
        required,
        minLength: minLength(8),
        maxLength: maxLength(64),
        containsUppercase: function(value) {
          return /[A-Z]/.test(value);
        },
        containsLowercase: function(value) {
          return /[a-z]/.test(value);
        },
        containsNumber: function(value) {
          return /[0-9]/.test(value);
        },
        containsSpecial: function(value) {
          return /[#?!@$%^&*-.]/.test(value);
        },
      },
      name: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(350),
      },
      email: { lowercase: (value) => value === value?.toLowerCase(), required, email },
      language: {
        required,
      },
      timezone: {
        required,
      },
    },
  },
  mounted() {
    this.init();
  },

  computed: {
    notification() {
      return this.$store ? this.$store.state.notification : null;
    },
    languages() {
      return this.$store.getters["localization/languages"];
    },
    timezones() {
      return this.$store.getters["localization/timezones"];
    },
    recaptchaKey() {
      return this.$store.getters["clientConfig/recaptchaKey"];
    },
    enableRecaptcha() {
      return this.$store.getters["clientConfig/enableRecaptcha"];
    },
  },

  methods: {
    init() {
      this.form.language = this.languages.find((l) => l.language == "tr");
      this.$store.dispatch("localization/fetchTimezones");
    },
    async register() {
      if (this.enableRecaptcha) {
        this.$refs.recaptcha.reset();
        this.$refs.recaptcha.execute();
      } else {
        await this.submit();
      }
    },
    async submit() {
      try {
        if (this.isRequesting) {
          return;
        }
        this.isRequesting = true;

        await this.$store.dispatch("user/register", {
          ...this.form,
          language: this.form.language.language,
        });
        this.$toast.success(this.$t("account.registered"));
        setTimeout(() => {
          this.isRequesting = false;
          window.location.href = "/login";
        }, 2000);
      } catch (error) {
        console.error(error);
        this.$handleHttpErrorByStatusCode(error);
        setTimeout(() => {
          this.isRequesting = false;
        }, 2000);
      }
    },

    async handleRecaptchaVerify(response) {
      if (response) {
        try {
          await this.submit();
        } catch (error) {
          console.error("Form submission error", error);
        }
      }
    },

    anyError(e) {
      this.formError = e;
    },
    onSelect() {
      this.$forceUpdate();
    },
  },
};
</script>

<style lang="scss" module></style>
